import fingEscudo from "../assets/logos/fing-escudo.png";

export function getAdministrativeUnitCode(user) {
  return (
    user?.administrative_unit?.code ||
    user?.administrative_unit_code ||
    user?.administrativeUnit?.code ||
    user?.administrativeUnitCode ||
    null
  );
}

export function isSuperPlusUltraUser(user) {
  return Boolean(
    user?.is_superusuarioplusultra ||
    user?.isSuperusuarioplusultra ||
    user?.can_access_superplusultra ||
    user?.canAccessSuperPlusUltra
  );
}

export function getAdministrativeUnitLogo(user) {
  if (isSuperPlusUltraUser(user)) {
    return null;
  }

  const unitCode = String(getAdministrativeUnitCode(user) || "");

  switch (unitCode) {
    case "4400":
      return {
        src: fingEscudo,
        alt: "Facultad de Ingeniería",
      };

    default:
      return null;
  }
}